import React from "react";

interface Props {
  children: React.ReactNode;
}

const ErrorMessage = (props: Props) => (
  <p className="my-3 text-sm text-rose-400">{props.children}</p>
);

export default ErrorMessage;
